// extracted by mini-css-extract-plugin
export var actionButton = "_rk-0";
export var actionMenuContainer = "_rk-i";
export var bubble = "_rk-2";
export var bubbleActionMenu = "_rk-j";
export var bubbleContext = "_rk-6";
export var bubbleItems = "_rk-7";
export var customer = "_rk-3";
export var divider = "_rk-8";
export var fileList = "_rk-9";
export var hiddenComment = "_rk-o";
export var infoAbove = "_rk-a";
export var internal = "_rk-4";
export var lightActionButton = "_rk-1";
export var link = "_rk-b";
export var merchant = "_rk-5";
export var message = "_rk-c";
export var profilePicture = "_rk-e";
export var quillToolbarContainer = "_rk-f";
export var senderDate = "_rk-g";
export var senderDateCustomer = "_rk-h";
export var senderName = "_rk-d";
export var time = "_rk-k";
export var uploadedImage = "_rk-l";
export var username = "_rk-m";
export var xsmall = "_rk-n";